<template>
  <div>
    <div>
      <div class="fixed-bottom bg-secondary text-white" v-if="canEditAuctions">
        <div class="container py-2">
          <div class="row" v-if="!loading">
            <div class="col-2 col-md-4">
              <img style="max-width:25px; filter:invert(1);" class="mr-2" src="/assets/img/nova.png"/>
              <span class="d-none d-md-inline">A10 Admin Bar</span>
            </div>
            <div class="col-10 col-md-8">
              <ul class="list-unstyled">
                <li class="float-left mr-3">
                  <a class="font-weight-bold text-white no-underline" target="_blank"
                     :href="'/nova/resources/auctions/'+auction.id+'/edit'">Edit Auction</a>
                </li>
                <li class="float-left mr-3">
                  <a class="font-weight-bold text-white no-underline" target="_blank"
                     :href="'/nova/resources/auctions/'+auction.id">Auction Details</a>
                </li>
                <li class="float-left mr-3" v-if="canEditAuctions && confirm_sync===false && !syncing">
                                <span @click="confirm_sync=true"
                                      class="font-weight-bold text-white nounderline cursor-pointer">Sync Auction</span>
                </li>
                <li class="float-left mr-3" v-if="canEditAuctions && confirm_sync===true && !syncing">
                                    <span @click="erpSync"
                                          class="font-weight-bold text-warning nounderline cursor-pointer">Confirm Auction Sync</span>
                </li>
                <li class="float-left mr-3 pr-3" style="background-color:#444; border-radius:10px;"
                    v-if="syncing">
                  <svg version="1.1" id="da-loader" xmlns="http://www.w3.org/2000/svg" fill="#fff"
                       xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px"
                       height="20px"
                       viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;"
                       xml:space="preserve">
                                    <path fill="#fff"
                                          d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path></svg>
                  <span class="font-weight-bold text-white">Syncing</span>
                </li>
              </ul>

            </div>
          </div>
          <div class="loader center-vertically" v-if="loading">
            <svg version="1.1" id="da-loader" xmlns="http://www.w3.org/2000/svg" fill="#fff"
                 xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px"
                 viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
        <path fill="#fff"
              d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path>
      </svg>
          </div>
        </div>
      </div>
      <div class="container-fluid auction pt-5">

        <div class="row">
          <div class="col-lg-4 order-2 order-lg-1 offset-lg-1">
            <div class="h6 text-capitalize text-muted">{{ __('auction') + ' ' + auctionNumber }}</div>
            <div class="font-weight-bold mb-5 auctionTitle">
              <h1 class="h2 mobileAuctionTitle">{{ auctionTitle }}</h1>
              <a
                  v-if="settings && auction.auction_is_live !== 0"
                  :href="artmarkLiveLink"
                  class="live_status auction_live_now mt-2 p-2 d-inline-block h7 nounderline"
              >
                <strong>{{ __LIVE('auction-is-live') }}</strong>
              </a>
            </div>
            <!-- <div class="media-body auction-description border-top border-bottom py-3 mb-0 done d-lg-none h7" v-html="auction.description"></div> -->
            <div
                v-if="auction.description && auction.description.length < 120"
                v-html="auction.description"
                class="media-body auction-description border-top border-bottom py-3 mb-0 done d-lg-none h7"
            ></div>
            <div
                v-else-if="auction.description && auction.description.length >= 120"
                class="media-body auction-description border-top border-bottom py-3 mb-0 done d-lg-none h7"
            >
              <span v-html="description.content"></span>
              <button class="toggle-more" @click="toggleMore">
                <span v-if="description.more">{{ __('read-more') }}</span>
                <span v-else>{{ __('read-less') }}</span>
              </button>
            </div>
            <div class="auction-catalogue-download col-lg-10">
              <a class="btn btn-dark rounded-0 h7 text-uppercase align-items-center my-2 mr-3 btnMobile"
                 :href="route('register')"
                 v-if="!loggedIn">{{ __('register-auction') }}</a>
              <nav class="nav d-flex justify-content-lg-start flex-row m-0"
                   :class=" loggedIn && hasCalendar ? 'nav-auction-logged-calendar' : ''">

                <!-- <a class="nav-link" href="#">{{__('browse-catalog')}}</a> -->
                <a
                    href="#"
                    v-if="auction.display_start_timestamp >= Date.now() && auction.calendar_link_google && auction.calendar_link_ics"
                    class="text-uppercase nounderline h7 py-2 auction-top-button align-self-center btnMobile"
                    data-toggle="modal"
                    data-target="#calendarModal"
                >{{ __('add_to_calendar') }}</a>

                <a
                    v-if="auction.catalog"
                    class="text-uppercase nounderline h7 py-2 auction-top-button align-self-center btnMobile"
                    :href="auction.catalog"
                    target="_blank"
                >{{ __('download-catalog') }}</a>
                <a
                    v-if="auction.parent_id == 3 || auction.parent_id == 110"
                    class="text-uppercase nounderline h7 py-2 auction-top-button align-self-center btnMobile"
                    :href="amLiveLink">
                  {{ __('bid-online') }}
                </a>

                <!-- <a class="text-uppercase nounderline h7 py-2 catalog-pdf pl-2" href="#">{{__('erata')}}</a>  -->
                <!-- <a class="nav-link" href="#">{{__('compare-catalogs')}}</a> -->
              </nav>

            </div>
            <hr class="m-0"/>
            <div class="d-flex d-md-none justify-content-start">
              <a style="margin-left: 0 !important;"
                 id="filtersDetailsToggle"
                 class="text-uppercase h7 py-2 ml-3"
                 @click="filtersDetailsHidden = !filtersDetailsHidden"
              ><u>{{ __('show_hide_details_filters') }}</u></a>
            </div>

            <div
                v-if="filtersDetailsHidden"
                :class="{filtersDetailsHidden : 'd-none'}"
                id="filtersDetailsToolbar"
                class="d-md-none toolbar justify-content-between offset-lg-1 col-lg-10 my-4"
            >

              <div class="row center-vertically">
                <div class="col-sm-3 h6 text-uppercase font-weight-bold py-2 m-0">{{ __('auction') }}
                </div>
                <div class="col-sm-9 m-0 py-2 text-left h7">
                  <span
                      :style="auction.highlight_start_date
                          ? 'font-weight: bold !important; color: red !important;'
                          : ''"
                  >
                    {{ auction.display_start_date }}

                    <template v-if="auction.show_display_location">
    <br/>
                      {{ auction.display_location }}
                    </template>
              </span>
                </div>
              </div>
              <hr class="m-0"/>
              <div class="row center-vertically">
                <div class="col-sm-3 h6 text-uppercase font-weight-bold py-2 m-0">{{ __('lots') }}</div>
                <div class="col-sm-9 m-0 py-2 text-left">
                  <span>{{ total_lots }}</span>
                </div>
              </div>
              <hr class="m-0"/>
              <div class="row center-vertically" v-if="hasVirtualGallery!= null">
                <div class="col-sm-3 h6 text-uppercase font-weight-bold py-2 m-0">{{ __('exhibition') }}
                </div>
                <div class="col-sm-9 m-0 py-2 text-left">
                  <button v-for="(galleryID, index) in hasVirtualGallery.split(',')"
                          :galleryID="galleryID" :index="index"
                          type="button"
                          name="button"
                          class="btn btn-dark rounded-0 float-left h8"
                          style="margin-right: 5px !important;"
                  >
                    <a style="color: white; text-decoration: none;"
                       :href="'https://www.artmark.ro/' + (locale() === 'ro' ? 'ro/galerie-virtuala/' : 'en/virtual-gallery/') + galleryID"
                       target="_blank">
                      {{ __('visit_exhibition') + ' #' + (++index) }}
                    </a>
                  </button>
                </div>
              </div>
              <hr v-if="hasVirtualGallery != null" class="m-0"/>
              <div class="row center-vertically" v-if="auction.exhibition && auction.parent_id != 3">
                <div class="col-sm-3 h6 text-uppercase font-weight-bold py-2 m-0">{{ __('exhibition') }}
                </div>
                <div class="col-sm-9 m-0 py-2 text-left">
                  <span v-html="auction.exhibition" class="h7"></span>
                </div>
              </div>
              <hr v-if="auction.exhibition && auction.parent_id != 3" class="m-0"/>
              <div class="row center-vertically" v-if="auction.parent_id == 3">
                <div class="col-sm-3 h6 text-uppercase font-weight-bold py-2 m-0">{{ __('results') }}
                </div>
                <div class="col-sm-9 m-0 py-2 text-left">
                  {{ __('sale_total') }}:
                  <span class="text-dark">{{ auction.total }} &euro;</span>
                  <br/>
                  {{ __('total_sale_percentage') }}:
                  <span class="text-dark">{{ auction.sold_rate }}&#37;</span>
                </div>
              </div>
              <hr v-if=" auction.parent_id == 3" class="m-0"/>
              <div class="share-the-love"></div>
            </div>
            <div class="d-none d-sm-block toolbar justify-content-between col-lg-10 my-4">
              <div class="row center-vertically">
                <div class="col-sm-3 h6 text-uppercase font-weight-bold py-2 m-0">{{ __('auction') }}
                </div>
                <div class="col-sm-9 m-0 py-2 text-left h7">
                  <span
                      :style="auction.highlight_start_date
                          ? 'font-weight: bold !important; color: red !important;'
                          : ''"
                  >
                    {{ auction.display_start_date }}

                    <template v-if="auction.show_display_location">
                                      <br/>
                      {{ auction.display_location }}
                    </template>
              </span>
                </div>
              </div>
              <hr class="m-0"/>
              <div class="row center-vertically">
                <div class="col-sm-3 h6 text-uppercase font-weight-bold py-2 m-0">{{ __('lots') }}</div>
                <div class="col-sm-9 m-0 py-2 text-left">
                  <span>{{ total_lots }}</span>
                </div>
              </div>
              <hr class="m-0"/>
              <div class="row center-vertically" v-if="hasVirtualGallery!= null">
                <div class="col-sm-3 h6 text-uppercase font-weight-bold py-2 m-0">{{ __('exhibition') }}
                </div>
                <div class="col-sm-9 m-0 py-2 text-left">
                  <button v-for="(galleryID, index) in hasVirtualGallery.split(',')"
                          :galleryID="galleryID" :index="index"
                          type="button"
                          name="button"
                          class="btn btn-dark rounded-0 float-left h8"
                          style="margin-right: 5px !important;"
                  >
                    <a style="color: white; text-decoration: none;"
                       :href="'https://www.artmark.ro/' + (locale() === 'ro' ? 'ro/galerie-virtuala/' : 'en/virtual-gallery/') + galleryID"
                       target="_blank">
                      {{ __('visit_exhibition') + ' #' + (++index) }}
                    </a>
                  </button>
                </div>
              </div>
              <hr v-if="auction.exhibition == null" class="m-0"/>
              <div class="row center-vertically" v-if="auction.exhibition && auction.parent_id != 3">
                <div class="col-sm-3 h6 text-uppercase font-weight-bold py-2 m-0">{{ __('exhibition') }}
                </div>
                <div class="col-sm-9 m-0 py-2 text-left">
                  <span v-html="auction.exhibition" class="h7"></span>
                </div>
              </div>
              <hr v-if="auction.exhibition && auction.parent_id != 3" class="m-0"/>
              <div class="row center-vertically" v-if="auction.parent_id == 3">
                <div class="col-sm-3 h6 text-uppercase font-weight-bold py-2 m-0">{{ __('results') }}
                </div>
                <div class="col-sm-9 m-0 py-2 text-left">
                  {{ __('sale_total') }}:
                  <span class="text-dark">{{ auction.total }} &euro;</span>
                  <br/>
                  {{ __('total_sale_percentage') }}:
                  <span class="text-dark">{{ auction.sold_rate }}&#37;</span>
                </div>
              </div>
              <hr v-if="auction.parent_id == 3" class="m-0"/>
              <div class="share-the-love"></div>
            </div>
          </div>
          <div class="col-lg-5 order-1 offset-lg-1">
            <div class="media d-block" id="auction-img-main">
              <img
                  :src="img"
                  :alt="auction.name"
                  class="w-100 mb-5 border"
                  v-if="auction.video_embed==null"
              />
              <div v-else-if="auction.video_embed">
                <div v-if="!auction.video_embed.includes('<iframe')" class="main-carousel">
                  <div v-for="v in auction.video_embed.split(',')" class="carousel-cell video-wrap">
                    <iframe
                        :src="youtubeSrc(v)"
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                        style="width:100%; min-height:300px;"
                    ></iframe>

                    <div class="video-wrap__grippy"></div>
                    <div class="video-wrap__grippy"></div>
                  </div>
                </div>
                <div v-else class="responsive-iframe-container" v-html="auction.video_embed"></div>
              </div>
              <!-- <div v-if="auction.description" class="media-body auction-description border-top border-bottom py-3 d-none d-lg-block h7" v-html="trim(auction.description)"></div> -->
              <div v-if="(auction.parent_id == 3) && (auction.offer_status == 3)"
                   class="media-body auction-description border-top border-bottom py-3 d-none d-lg-block h7">
                <span>{{ __('postAuctionDescription') }}</span>
              </div>
              <div v-else>
                <div
                    v-if="auction.description && auction.description.length < 120"
                    v-html="auction.description"
                    class="media-body auction-description border-top border-bottom py-3 d-none d-lg-block h7"
                ></div>
                <div
                    v-else-if="auction.description && auction.description.length >= 120"
                    class="media-body auction-description border-top border-bottom py-3 d-none d-lg-block h7"
                >
                  <span v-html="description.content"></span>
                  <button class="toggle-more" @click="toggleMore">
                    <span v-if="description.more">{{ __('read-more') }}</span>
                    <span v-else>{{ __('read-less') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-start" v-if="window.innerWidth < 960">
        <a
            id="filtersToggle"
            class="text-uppercase h7 py-2 ml-3"
            @click="filtersHidden = !filtersHidden"
        ><u>{{ __('show_hide_filters') }}</u></a>
      </div>
      <div
          v-if="!filtersHidden"
          :class="{filtersHidden : 'd-none'}"
          id="filtersToolbar"
          class="d-md-block toolbar justify-content-between offset-lg-1 col-lg-10 my-4"
      >
        <div class="row">
          <div v-if="$isMobile()" class="col-lg-4 d-flex flex-column py-3">
            <h6 class="h7 text-uppercase text-muted">{{ __('choose_a_lot') }} {{ total_lots }}</h6>
            <input
                class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder px-0"
                type="text"
                placeholder="Lot"
                v-model="lotJump"
                v-on:keyup="goToLot"
            />
            <button v-model="lotJump" type="button" name="button" @click="goToLotMobile"
                    class="btn btn-dark rounded-0 float-right h8 btn-buy-offer">
              {{ __('go_to_lot') }}
            </button>
          </div>
          <div v-else class="col-lg-4 d-flex flex-column py-3">
            <h6 class="h7 text-uppercase text-muted">{{ __('choose_a_lot') }} {{ total_lots }}</h6>
            <input
                class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder px-0"
                type="text"
                placeholder="Lot"
                v-model="lotJump"
                v-on:keyup="goToLot"
            />
          </div>
          <div class="col-lg-4 d-flex flex-column py-3">
            <h6 class="h7 text-uppercase text-muted">{{ __('order_lots_by') }}</h6>
            <select v-if="auction.parent_id != 3" v-model="lot_order"
                    class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder px-0">
              <option :value="v" v-for="(v, k) in ordering_options">{{ __(k) }}</option>
            </select>
            <select v-if="auction.parent_id == 3" v-model="results_lot_order"
                    class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder px-0">
              <option :value="v" v-for="(v, k) in  results_ordering_options">{{ __(k) }}</option>
            </select>
          </div>
          <div class="col-lg-4 d-flex flex-column py-3">
            <h6 class="h7 text-uppercase text-muted">{{ __('lots_per_page') }}</h6>
            <select v-model="show_per_page"
                    class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder px-0"
                    name="auction-lots-per-page">
              <option v-if="v <= lots.length" :value="v" v-for="v in per_page_options">{{ v }}
              </option>
              <option :value="lots.length">{{ __('all') }} ({{ lots.length }})</option>
            </select>
          </div>
        </div>
      </div>
      <div class="container-fluid" :class="{'center-vertically': lots.length === 0}">
        <div class="loader mb-5" v-if="loading">
          <svg
              version="1.1"
              id="da-loader"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="40px"
              height="40px"
              viewBox="0 0 50 50"
              style="enable-background:new 0 0 50 50;"
              xml:space="preserve"
          >
          <path
              fill="#000"
              d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
          >
            <animateTransform
                attributeType="xml"
                attributeName="transform"
                type="rotate"
                from="0 25 25"
                to="360 25 25"
                dur="0.6s"
                repeatCount="indefinite"
            />
          </path>
        </svg>
        </div>
        <div v-if="(lots.length === 0) && !loading" class="mb-5">
          <h4 class="h5 text-muted m-0">{{ __('lots_available_soon') }}</h4>
        </div>
        <div v-if="lots.length > 0" class="row">
          <lot
              v-if="lot.status === 1"
              :class="lot.number === 1 ? 'first-auction-lot' : ''"
              :auction="auction"
              :lot="lot"
              :key="lot.id"
              v-for="lot in segment"
          />
        </div>
        <div v-if="lots.length > 0 && !loading" class="row pagination">

          <div class="col-1"></div>
          <div class="col text-center my-3">
            <nav aria-label="labels" style="background: white !important;">
              <ul class="pagination justify-content-center mb-5">
                <li class="page-item prev" :class="hasPrevious">
                  <router-link
                      class="page-link"
                      :to="{name: 'auction', params: {sold: sold, page: prevPage }}"
                      :aria-label="__('prevpage')"
                  >
                    <svg
                        width="40"
                        height="40"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <polyline fill="none" stroke="#000" stroke-width=".5"
                                points="13 16 7 10 13 4"/>
                    </svg>
                  </router-link>
                </li>
                <li class="page-item" :class="isCurrentPage(p)" v-for="p in proximityPages">
                  <router-link
                      class="page-link"
                      :to="{name: 'auction', params: {sold: sold, page: p}}"
                      :aria-label="__('page')"
                  >{{ p }}
                  </router-link>
                </li>
                <li class="page-item next" :class="hasNext">
                  <router-link
                      class="page-link"
                      :to="{name: 'auction', params: {sold: sold, page: nextPage}}"
                      :aria-label="__('nextpage')"
                  >
                    <svg
                        width="40"
                        height="40"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <polyline fill="none" stroke="#000" stroke-width=".5"
                                points="7 4 13 10 7 16"/>
                    </svg>
                  </router-link>
                </li>
              </ul>
            </nav>
          </div>
          <div class="col-1"></div>
        </div>

      </div>
      <div class="col-1"></div>
    </div>
    <!-- Calendar Modal -->
    <div
        class="modal fade p-0"
        id="calendarModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="calendarModal"
        aria-hidden="true"
        v-if="auction.calendar_link_google && auction.calendar_link_ics"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="link">
        <div class="modal-content rounded-0">
          <div class="modal-header">
            <h4 class="modal-title h5">{{ __('add_to_calendar') }}</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <h5
              class="h5 text-center text-muted mt-5 mb-3 px-3"
          >{{ __('calendar_modal_select_an_option') }}</h5>
          <div class="row px-3 py-3">
            <a
                :href="auction.calendar_link_google"
                @click="open_link(auction.calendar_link_google)"
                class="col-4 h5 nounderline text-center m-0 py-3"
                target="_blank"
                data-dismiss="modal"
            >Google</a>
            <a
                :href="auction.calendar_link_ics"
                @click="open_link(auction.calendar_link_ics)"
                class="col-4 h5 nounderline text-center m-0 py-3"
                target="_blank"
                data-dismiss="modal"
            >Outlook</a>
            <a
                :href="auction.calendar_link_ics"
                @click="open_link(auction.calendar_link_ics)"
                class="col-4 h5 nounderline text-center m-0 py-3"
                target="_blank"
                data-dismiss="modal"
            >iPhone</a>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" tabindex="-1" role="dialog" id="favoritesModal">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ __('favorites-modal') }}</h5>
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 0 !important;">
            <div class="col-12">
              <h5 class="h5 text-center text-muted my-4 px-3">{{ __('login') }}</h5>
              <div class="px-3 row" v-if="!loadingLogin">
                <div class="col-12 form-group">
                  <input ref="username_login" id="username_login"
                         class="chrome-autofill-hack form-control bg-light myAccount-form-control-custom"
                         type="email" placeholder=" " required autofocus/>
                  <label class="form-control-placeholder" for="username_login">
                    <span>{{ __('email') }}</span>
                  </label>
                </div>
                <div class="col-12 form-group">
                  <input ref="password_login" id="password_login"
                         class="chrome-autofill-hack form-control bg-light myAccount-form-control-custom"
                         type="password" placeholder=" " required/>
                  <label class="form-control-placeholder" for="password_login">
                    <span>{{ __('Password') }}</span>
                  </label>
                </div>
                <div class="col-12 d-flex justify-content-center mt-4">
                  <button @click="loginUser()" type="button"
                          class="btn action_box w-100 action_box_full_width_mobile rounded-0">{{ __('login') }}
                  </button>

                </div>

              </div>
              <div class="w-100 px-2">
                <div class="iziToast-wrapper-modal px-2"></div>
              </div>
              <div class="col-12">
                <a class="btn btn-link text-dark nounderline pl-0"
                   :href="route('forgot')">{{ __('forgot-pass') }}</a>
              </div>
              <div class="col-12 d-flex pt-4">
                <a class="h6 nounderline" :href="route('register')">{{ __('no-account-register') }}</a>
              </div>

            </div>
          </div>
          <div class="modal-footer">
          </div>
        </div>
      </div>
    </div>
    <v-tour name="gridTour" :steps="steps" :options="myOptions">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
              v-if="tour.steps[tour.currentStep]"
              :key="tour.currentStep"
              :step="tour.steps[tour.currentStep]"
              :previous-step="tour.previousStep"
              :next-step="tour.nextStep"
              :stop="tour.stop"
              :skip="tour.skip"
              :is-first="tour.isFirst"
              :is-last="tour.isLast"
              :labels="tour.labels" style="background: #343a40 !important;">
            <template v-if="tour.currentStep === 1">
              <div slot="actions">
                <button @click="tour.stop" class="v-step__button v-step__button-stop">{{ __('buttonStop') }}</button>
              </div>
            </template>
            <template v-if="tour.currentStep === 0">
              <div slot="actions">
                <button @click="tour.stop" class="v-step__button v-step__button-stop">{{ __('buttonSkip') }}</button>
                <button @click="tour.nextStep; scrollTour(event)" class="v-step__button v-step__button-next">
                  {{ __('buttonNext') }}
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>
<style>
.flickity-button-icon {
  fill: white !important;
}

@media (max-width: 575.98px) {
  .auctionTitle {
    margin-bottom: 0 !important;

  }

  .mobileAuctionTitle {
    font-size: 1.2rem !important;
  }

  .nav-auction-logged-calendar .btnMobile {
    font-size: 0.5rem !important;
    margin-right: 0.4rem !important;
  }
}

</style>


<script>

import {APP} from "../constants.js";
import {mapGetters} from "vuex";
import * as types from "../store/mutations";
import store from "../store";
import Flickity from 'vue-flickity'

export default {
  data: function () {
    return {
      flickityOptions: {
        lazyLoad: true,
        imagesLoaded: false,
        cellAlign: 'center',
        adaptiveHeight: true,
        contain: true,
        autoPlay: true,
        wrapAround: true,
        fade: true,
        pageDots: false,
        prevNextButtons: false,
      },
      lotJump: "",
      loading: false,
      loadingLogin: false,
      total_lots: "-",
      more: false,
      filtersHidden: false,
      filtersDetailsHidden: false,
      confirm_sync: false,
      syncing: false,
      steps: [
        {
          target: 'body',
          content: window.AG.locale == 'ro' ? 'Avem noi opțiuni! Le prezentăm mai jos!' : 'New features for you! Let us show you!',
          params: {
            placement: 'none',
            modifiers: {
              computeStyle: {
                enabled: true,
                fn(data) {
                  data.styles = Object.assign({}, data.styles, {
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                  });
                  return data;
                }
              }
            }
          }
        },
        {
          target: '#btn-favorite',
          content: window.AG.locale == 'ro' ? 'Click și opera ajunge în secțiunea de Favorite iar noi te anunțăm când intră în licitație!' : "Click and we'll add it to Favorites and warn you before the auction!",
          params: {
            placement: 'bottom',
            enableScrolling: false
          }

        }
      ],
      myOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: window.AG.locale == 'ro' ? 'Sari peste tur' : 'Skip the tour',
          buttonPrevious: window.AG.locale == 'ro' ? 'Pasul anterior' : 'Previous step',
          buttonNext: window.AG.locale == 'ro' ? 'Vezi pasul următor' : 'Next step',
          buttonStop: window.AG.locale == 'ro' ? 'Am înțeles!' : 'Got it!'
        }
      }
    }
  },
  components: {
    Flickity,
  },
  props: ["page", "register", "link", "token"],
  computed: {
    console: () => console,
    window: () => window,
    description: function () {
      if (!this.auction.description) return;

      let n = 120;

      if (this.auction.description.length <= n || this.more) {
        return {
          content: this.auction.description,
          more: false
        };
      }
      var subString = this.auction.description.substr(0, n - 1);
      return {
        content: subString.substr(0, subString.lastIndexOf(" ")) + "&hellip;",
        more: true
      };
    },
    artmarkLiveLink: function () {
      return window.AG.artmark_live;
    },
    amLiveLink: function () {
      return window.AG.am_live;
    },
    settings: function () {
      return window.AG.settings.live_auction;
    },
    canEditLots: function () {
      return window.AG.caneditlots;
    },
    canEditAuctions: function () {
      return window.AG.caneditauctions;
    },
    hasVirtualGallery: function () {
      return this.auction.virtual_gallery;
    },
    hasExhibition: function () {
      return this.auction.exhibition;
    },
    img: function () {
      if (this.auction.additional_image_url && this.auction.status == 1) {
        return this.auction.additional_image_url;

      } else {
        return this.auction.main_image_url;
      }
    },
    per_page_options: function () {
      return APP.LOTS_PER_PAGE.VALUES;
    },
    ordering_options: function () {
      return APP.LOT_ORDER;
    },
    results_ordering_options: function () {
      return APP.RESULTS_LOT_ORDER;
    },
    auction: function () {
      return window.AG.auction;
    },
    loggedIn: function () {
      return window.AG.loggedIn;
    },
    hasCalendar: function () {
      return (this.auction.display_start_timestamp >= Date.now() && this.auction.calendar_link_google && this.auction.calendar_link_ics);
    },
    auctionTitle: function () {
      if (this.auction.name.indexOf("#") !== -1) {
        return this.auction.name.slice(0, this.auction.name.indexOf("#"));
      }
      if (this.auction.id == 1026) {
        if (window.AG.locale == 'ro') {
          return '“Legends“. Licitație de sport, muzică și obiecte de colecție contemporane'
        } else {
          return '“Legends“. Auction of sports, music, and contemporary collectibles'
        }
      }
      return this.auction.name;
    },
    auctionNumber: function () {
      if (this.auction.name.indexOf("#") !== -1) {
        return this.auction.name.slice(
            this.auction.name.indexOf("#"),
            this.auction.name.length - 5
        );
      }
      return "#" + this.auction.order;
    },
    lots: function () {
      return this.$store.getters.lots;
    },
    show_per_page: {
      get: function () {
        return this.show;
      },
      set: function (show) {
        this.$store.commit(types.AUCTION_SET_SHOW, show);
        this.$router.push({
          name: "auction",
          params: {
            auction: this.auction.slug
          }
        });
      }
    },
    lot_order: {
      get: function () {
        return this.order;
      },
      set: function (order) {
        this.$store.commit(types.AUCTION_SET_ORDER, order);
        this.$router.push({
          name: "auction",
          params: {
            auction: this.auction.slug,
            t: new Date().getTime(),
          }
        }).catch(() => {
        });
      }
    },
    results_lot_order: {
      get: function () {
        return this.results_order;
      },
      set: function (results_order) {
        this.$store.commit(types.AUCTION_RESULTS_SET_ORDER, results_order);
        if (results_order === 4 || results_order === 5) {
          var sold_lots = results_order === 4 ? (locale === 'ro' ? 'adjudecate' : 'sold') : '';
          var unsold_lots = results_order === 5 ? (locale === 'ro' ? 'neadjudecate' : 'not-sold') : '';
          var redirectTo = results_order === 4 ? sold_lots : unsold_lots;
          this.$router.push({
            name: "auction",
            params: {
              auction: this.auction.slug,
              sold: redirectTo
            }
          });
        } else {
          this.$router.push({
            name: "auction",
            params: {
              auction: this.auction.slug
            }
          }).catch(err => {
            //for pagination refresh when filtering
          });
        }
      }
    },
    segment: function () {
      return this.lots.slice(
          (this.currentPage - 1) * this.show,
          (this.currentPage - 1) * this.show + this.show
      );
    },
    pages: function () {
      var start = 1;
      var end = Math.ceil(this.lots.length / this.show);
      return Array(end - start + 1)
          .fill()
          .map((item, index) => start + index);
    },
    hasPrevious: function () {
      return this.currentPage == 1 ? "disabled" : "";
    },
    hasNext: function () {
      return this.currentPage == this.lots.length / this.show ? "disabled" : "";
    },
    nextPage: function () {
      return parseInt(this.currentPage) + 1;
    },
    prevPage: function () {
      return parseInt(this.currentPage) - 1;
    },
    sold: function () {
      return this.$route.params.sold;
    },
    currentPage: function () {
      if (window.AG.currentPage)
        return window.AG.currentPage;
      return this.page || 1;
    },
    proximityPages() {
      if (!this.currentPage) {
        return "";
      }
      var curr = parseInt(this.currentPage);
      var total = Math.ceil(this.lots.length / this.show);
      var pages = [
        curr - 3,
        curr - 2,
        curr - 1,
        curr,
        curr + 1,
        curr + 2,
        curr + 3
      ].filter(function (value) {
        if (value <= 0) {
          return false;
        } else if (value > total) {
          return false;
        }
        return true;
      });
      return pages;
    },
    ...mapGetters({
      show: "show",
      order: "order",
      results_order: "results_order"
    })
  },
  methods: {
    locale: function () {
      return window.AG.locale;
    },
    youtubeSrc(id) {
      const locale = this.locale();
      const params = new URLSearchParams({
        cc_load_policy: 0,
        hl: locale,
        cc_lang_pref: locale,
      });

      return `https://www.youtube.com/embed/${id}?${params.toString()}`;
    },
    scrollTour: function (event) {
      this.$tours['gridTour'].nextStep();
      var lotRow = document.getElementsByClassName('first-auction-lot');
      lotRow[0].scrollIntoView();
    },
    erpSync: function () {
      let bodyFormData = new FormData();
      bodyFormData.set('external_id', this.auction.external_id);
      bodyFormData.set('sync_action', 'sync-auction');
      this.syncing = true;

      let that = this;
      axios({
        method: 'post',
        url: '/api/erp-sync',
        data: bodyFormData,
        config: {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        }
      }).then((response) => {
        that.syncing = false,
            that.confirm_sync = false,
            window.showToast(response.data.message, "success", 'bottomRight');
      }).catch((error) => {
        that.syncing = false,
            that.confirm_sync = false
        window.showToast(error.response.data.message, "error", 'bottomRight');
      })
    },
    toggleMore: function () {
      this.more = !this.more;
    },
    open_link: function (url) {
      window.open(url, "_blank");
    },
    trim: function (value) {
      value = value.replace(/(^\s*)|(\s*$)/gi, "");
      value = value.replace(/[ ]{2,}/gi, " ");
      value = value.replace(/\n /, "\n");
      try {
        value = value.trimStart();
        value = value.trimEnd();
      } catch (err) {
        //supress errors for trim
      }

      return value;
    },
    __: function (key) {
      return window.AG.trans[key];
    },
    __LIVE: function (key) {
      return window.AG.generic[key];
    },
    route: function (key) {
      return window.AG.routes[key];
    },
    goToLot: function (ev) {
      switch (ev.keyCode) {
        case 13: // henter
          if (this.lotJump) {
            var lot = this.lots.find(lot => lot.number == this.lotJump);
            if (lot != undefined) {
              this.$router.push({
                name: "lot",
                params: {
                  auction: this.auction.slug,
                  lot: lot.slug
                }
              });
            }
          }
          break;
        case 27: // hescape
          this.lotJump = "";
          break;
      }
    },
    goToLotMobile: function () {
      if (this.lotJump) {
        var lot = this.lots.find(lot => lot.number == this.lotJump);
        if (lot != undefined) {
          this.$router.push({
            name: "lot",
            params: {
              auction: this.auction.slug,
              lot: lot.slug
            }
          });
        }
      }
    },
    isCurrentPage: function (page) {
      return this.currentPage == page ? "active" : "";
    },
    setCookie: function (name, value) {
      var cookieDate = new Date();
      cookieDate.setFullYear(cookieDate.getFullYear() + 10);

      var cookie = name + "=" + JSON.stringify(value) + "; expires=" + cookieDate.toUTCString();
      document.cookie = cookie;
    },
    getCookie: function (name) {
      var cookieArr = document.cookie.split(";");
      var found = null;

      for (var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split("=");
        if ('tours' == cookiePair[0].trim()) {
          JSON.parse(cookiePair[1], (key, value) => {
                if (key === name) {
                  found = value;
                }
              }
          );
        }
      }
      return found;
    },
    openShareModal: function (event) {
      var targetUrl = this.url;
      $('#shareModal').on('show.bs.modal', function (e) {
        $('#facebookShare').attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href + "&amp;display=popup")
      });
      event.preventDefault();
    },
    loginUser: function () {
      let user = this.$refs.username_login.value;
      let pass = this.$refs.password_login.value;

      if (!user || !pass) {
        return;
      }

      this.loadingLogin = true;
      let url = window.AG.locale == 'ro' ? '/ro/autentificare' : '/en/login';

      var bodyFormData = new FormData();
      bodyFormData.set("email", user);
      bodyFormData.set("password", pass);

      axios({
        method: "post",
        url: url,
        data: bodyFormData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      }).then((response) => {
        location.reload();
        this.loadingLogin = false;
        this.loginModal = false;
      }).catch((error) => {
        if (error.response.status === 401) {
          this.loadingLogin = false;
          window.showToast(
              error.response.data.message,
              "error",
              null,
              ".iziToast-wrapper-modal"
          );
        } else {
          this.loadingLogin = false;
          this.loginModal = false;
          window.showToast(error.response.data.message, "error", "bottomCenter");
          location.reload();
        }
      });

    },
    // onResize() {
    //     this.filtersHidden = window.innerWidth < 960;
    // },
  },
  filters: {
    dayjs: function (date) {
      return $dayjs(date).format("MMMM Do YYYY, h:mm:ss a");
    }
  },
  created() {
    // if(window.AG) {
    //   this.$dayjs.locale(window.AG.locale);
    // }
    // if(![9, 24, 48, 96].includes(this.show_per_page) && this.lots.length != this.show_per_page) {
    //   this.show_per_page = this.lots.length
    // }
    this.loading = true;
    let vm = this;
    if (window.AG) {
      this.$dayjs.locale(window.AG.locale);
    }
    this.$store.dispatch("loadAuction").then(data => {
      this.loading = false;
      if (
          ![9, 24, 48, 96].includes(vm.show_per_page) &&
          vm.lots.length != vm.show_per_page
      ) {
        vm.show_per_page = vm.lots.length;
      }
    });
  },
  // beforeRouteEnter (to, from, next) {
  //   let vm = this
  //   store.dispatch('loadAuction').then(data => {
  //     next()
  //   });
  // },
  beforeCreate() {
    this.$store.commit(types.AUCTION_INIT);
  },
  beforeDestroy() {
    if (typeof window === 'undefined') return

    window.removeEventListener('resize', this.onResize, {passive: true})
  },
  mounted() {
    console.log('auction mounted');
    //this.onResize()

    //window.addEventListener('resize', this.onResize, {passive: true})

    // var seenLotTour = this.getCookie('lotTour');
    // var seenGridTour = this.getCookie('gridTour');
    //
    // if( seenGridTour === null ) {
    //     this.$tours['gridTour'].start();
    //     var tours = [ { 'lotTour': seenLotTour}, {'gridTour':  true} ];
    //     this.setCookie('tours', tours);
    // }
  },
  updated() {
    if (this.$store.getters.initialLots.length === 0) this.total_lots = "-";
    else {
      let arr = [];
      this.$store.getters.initialLots.forEach(function (entry) {
        if (entry.auction_status !== 3 && entry.auction_status !== 4) {
          arr.push(entry);
        }
      });
      this.total_lots = arr.length;
    }
    if (this.$route.params.sold == 'not-sold' || this.$route.params.sold == 'neadjudecate') {
      this.$store.commit(types.AUCTION_RESULTS_SET_ORDER, 5);

    }
    if (this.$route.params.sold == 'sold' || this.$route.params.sold == 'adjudecate') {
      this.$store.commit(types.AUCTION_RESULTS_SET_ORDER, 4);
    }
    $('[data-toggle="modal"]').tooltip()
  }
};
</script>
